<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header icon="user" :content="header"/>
    </template>
    <template slot="main">
      <div v-if="isLoading" class="flex items-center justify-center h-dvh " style="height: 60dvh">
        <base-waiting-component :icon="loadingTableIcon" :text="getLoaderMessage"/>
      </div>
      <list-layout v-else>
        <template slot="header"> 
          <div class="px-4 lg:px-10">
            <el-form ref="sepa" >
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('SEPA.creditor_account_select')}}</label>
                  <el-form-item prop="PaymentType">
                    <el-select class="w-full" v-model="bankAccountSelected">
                      <el-option v-for="account in getBankAccountsCreditor"
                        :key="account.id"
                        :label="account.label"
                        :value="account.id"/>
                    </el-select>
                  </el-form-item>
            </el-form>
          </div>
        </template>
        <template slot="table-core">
            <base-table-pagination
              :total="pagination.total"
              :currentPage="pagination.currentPage"
              :perPage="pagination.pageSize"
              @changeCurrentPage="changeCurrentPage"
              @changePerPage="changePerPage"
              class="mb-4"
            ></base-table-pagination>
        </template>        
        <template slot="table-component">
          <kendo-grid-component
            ref="grid"
            v-model="selected"
            :value-key="['IdFacturae', 'IdInvoice', 'IdPendingPayment']"
            :spanish="spanish"
            :data='showedDebs'
            :kendo="kendo"
            :loading='loading'
            :selectedField="selectedField"
            :update-columns="false"
            @datastatechange='dataStateChange'>
          </kendo-grid-component>
          <Dialog
            :title="$t('SEPA.generate_file_sepa')"
            :visible.sync="showModal"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {showModal = false; generateSEPA();}"/>
              </div>
            </template>
        </Dialog>
        </template>
        <template slot="layout-extend">
          <div class= "flex flex-row px-4 lg:px-10 py-4" v-if="getSummary.totalDebtsSelected>0">
            <div class="px-2 w-full mb-2 lg:mb-0">
              <base-ro-input :label="$t('SEPA.summary.total_debts')" :data="getSummary.totalDebtsSelected"/>
            </div>
            <div class="px-2 w-full mb-2 lg:mb-0">
              <base-ro-input :label="$t('SEPA.summary.total_invoices')" :data="getSummary.totalInvoicesSelected"/>
            </div>
            <div class="px-2 w-full mb-2 lg:mb-0">
              <base-ro-input :label="$t('SEPA.summary.total_amount')" :data="getSummary.totalAmmount+' €'"/>
            </div>
          </div>
        </template>
      </list-layout>
    </template>
    <template slot="layout-extend">
       <base-footer>
          <template slot="actions">
            <base-button-responsive :text="$t('SEPA.actions.generate_file')"
              icon="check"
              :loading="loading"
              :disabled="false"
              @click="showModal = true"
            />
            <base-button-responsive
              :text=" $t('app.cancel')"
              icon="check"
              @click="goBack()"
              :loading="loading"
              :disabled="false"
            />
          </template>
        </base-footer>
    </template>
  </detail-layout-full-width>

</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import ListLayout from '@/components/layout/ListLayout.vue'
import BaseHeader from '@/components/base/BaseHeader.vue'
import { getSEPAAccountsByCompany } from '@/services/sepa/getSEPAAccountsFromCompany'
import { getSEPADebtorsByCompany } from '@/services/sepa/getSEPADebtorsByCompany'
import { generateSEPAFile } from '@/services/sepa/generateSEPAFile'
import { i18n } from '@/i18n'
import BaseWaitingComponent from '@/components/base/BaseWaitingComponent.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import { Dialog } from 'element-ui'

export default {
  components: { BaseHeader, ListLayout, DetailLayoutFullWidth, BaseWaitingComponent, KendoGridComponent, Dialog },
  name: 'sepa-emmit',
  data: () => {
    return {
      header: {
        title: i18n.t('SEPA.SEPA_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'companies'
      },
      creditor: {},
      bankAccountSelected: {},
      debtorsAccounts: [],
      debs: [],
      showedDebs: null,
      selected: [],
      spanish: true,
      loading: true,
      generatingSepa: false,
      loadingTableIcon: 'issued',
      loadingTableMessage: i18n.t('SEPA.loading_debs'),
      loadingFileMessage: i18n.t('SEPA.loading_file'),
      idCifEmpresa: -1,
      vuexnamespace: 'sepaEmmit',
      selectedField: 'selected',
      showModal: false,
    }
  },
  created: function () {
    this.idCifEmpresa = this.$route.params.id
  },
  mounted: function () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.loading = true
    this.getAccountsSEPA().then((data) => {
      if (data) {
        this.getDebtorsSEPA()
      }
    })
  },
  methods: {
    getAccountsSEPA: async function () {
      let hasCompanyAccount = false
      await getSEPAAccountsByCompany({ idCifEmpresa: this.idCifEmpresa })
        .then(data => {
          if (data.blnError) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
            this.goBack()
          } else {
            this.creditor = data.Respuesta
            hasCompanyAccount = this.creditor.BankAccounts.length > 0
            if (hasCompanyAccount) {
              this.bankAccountSelected = this.creditor.BankAccounts[0].SEPAIdentifier
            }
          }
        })
      return hasCompanyAccount
    },
    getDebtorsSEPA: async function () {
      getSEPADebtorsByCompany({ idCifEmpresa: this.idCifEmpresa })
        .then(data => {
          if (data.blnError) {
            if (data.codError === 'GSIC002') {
              this.doFeedback(data.msgError, 'warning')
            } else {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
            }
            this.goBack()
          } else {
            data.Respuesta.forEach(each => {
              each.DebtorAccounts.forEach(eachAccount => {
                if (this.debtorsAccounts.filter(filter => filter.DebtorTIN === each.DebtorTIN).filter(filter => filter.DebtorMandateId === eachAccount.DebtorMandateId).length === 0) {
                  this.debtorsAccounts.push({
                    DebtorTIN: each.DebtorTIN,
                    ...eachAccount
                  })
                }
              })
              const debts = each.Debts.flatMap(debt =>
                debt.PendingPayments.map(payment => ({
                  DebtorTIN: each.DebtorTIN,
                  DebtorName: each.DebtorName,
                  IdFacturae: debt.IdFacturae,
                  IdInvoice: debt.IdInvoice,
                  InvoiceSeriesCode: debt.InvoiceSeriesCode,
                  InvoiceNumber: debt.InvoiceNumber,
                  IdPendingPayment: payment.IdPendingPayment,
                  DebtAmmount: payment.DebtAmmount,
                  RequestedDate: payment.RequestedDate,
                  PaymentAccountDeclared: payment.PaymentAccountDeclared
                }))
              )
              this.debs.push(...debts)
              this.createPaginationObject()
            })
          }
          this.loading = false
          this.generateBreadcrums()
        })
    },
    goBack: function () {
      this.$router.push({ name: 'companies' })
    },
    generateSEPA: async function () {
      this.generatingSepa = true
      this.loading = true
      const debsSelected = this.selected.length > 0 ? this.selected : this.debs
      const payload = {
        IdCifEmpresa: this.idCifEmpresa,
        SEPAAccount: this.bankAccountSelected,
        PendingPayments: debsSelected.map(map => ({
          IdFacturae: map.IdFacturae,
          IdInvoice: map.IdInvoice,
          IdPendingPayment: map.IdPendingPayment
        }))
      }
      generateSEPAFile(payload).then(response => {
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = this.getFilenameOfFile()
        filename = decodeURI(filename)
        link.download = filename
        link.click()
        this.goBack()
      }).catch(error => {
        if (error.response?.data) {
          error.response.data.text().then(errorText => this.doFeedback(errorText))
        } else {
          this.doFeedback()
        }
        this.loading= false
      })
    },
    getFilenameOfFile: function () {
      return 'Fichero_Cobros_'+this.creditor.CreditorName+'_'+new Date(Date.now()-(new Date().getTimezoneOffset()*60*1000)).toISOString().split('T')[0]+'.xml'
    },
    generateBreadcrums: function () {
      const breadcrumbs = []
      breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })
      breadcrumbs.push({ path: '', name: this.creditor.CreditorName + ' ('+this.creditor.CreditorTIN+')' })
      this.header.breadcrumb = breadcrumbs
    },
    dataStateChange: function (event) {
      this.data = this.applyFilters()
    },
    changePerPage: function (event) {
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.kendo.take = event

      this.createPaginationObject(event, 1)
    },
    changeCurrentPage: function (page) {
      const pagination = this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', page)
      this.createPaginationObject(pagination.pageSize, page)
    },
    createPaginationObject (pageSize = 10, currentPage = 1) {
      const total = this.debs.length
      const totalPages = Math.ceil(total / pageSize)
      const pagination = {
        total: total,
        currentPage: currentPage,
        totalPages: totalPages,
        pageSize: pageSize
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.applyFilters()
    },
    applyFilters: function () {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      const end = start + this.pagination.pageSize
      this.showedDebs = this.debs.slice(start, end)
    },    
  },
  computed: {
    processMessage: function () {
      return this.$t('SEPA.generate_confirmation_message', { totalDebts: this.getSummary.totalDebtsSelected, totalAmmount: this.getSummary.totalAmmount })
    },
    getSummary: function () {
      let filteredDebs = this.debs
      if (this.selected.length !== 0) {
        filteredDebs = this.debs
          .filter(filter => this.selected.some(selectedItem => selectedItem.IdFacturae === filter.IdFacturae && selectedItem.IdInvoice === filter.IdInvoice && selectedItem.IdPendingPayment === filter.IdPendingPayment))
      }
      return {
        totalDebtsSelected: filteredDebs.length.toString(),
        totalInvoicesSelected: filteredDebs.reduce((acc, curr) => {
          const key = curr.IdFacturae + '|' + curr.IdInvoice
          if (!acc.map(map => map.key).includes(key)) {
            acc.push({ key: key })
          }
          return acc
        }, []).length.toString(),
        totalAmmount: filteredDebs
          .reduce((acc, curr) => acc + parseFloat(curr.DebtAmmount), 0).toFixed(2).toString().replace('.', ',')
      }
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    isLoading: function () {
      return this.loading
    },
    getBankAccountsCreditor: function () {
      return !this.hasCompanyAccount ? this.creditor.BankAccounts.map(map => {
        return {
          id: map.SEPAIdentifier,
          label: map.BankAccountAlias ? map.BankAccountAlias + ' ('+map.IBAN+')' : map.IBAN
        }
      }) : []
    },
    getLoaderMessage: function () {
      return !this.generatingSepa ? this.loadingTableMessage : this.loadingFileMessage
    }
  }
}
</script>

<style scoped>

.main-content .content-wrapper {
  width: 100%;
  height: 100%;
}
.main-content::v-deep > article > div {
  height: 100%;
  width: 100%;
}
.main-content::v-deep > article > div > div {
  height: 100%;
  padding: 0;
}

.base-ro-input::v-deep > span {
  border: olivedrab;
}

</style>
